import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAuthenticated } from "@/router/guardians"

export const InstructionsPathUri = {
  OCC_HEALTH_LAB_ORDER_INSTRUCTIONS: "/occupational-health-lab-order-instructions",
  URGENT_CARE_LAB_ORDER_INSTRUCTIONS: "/urgent-care-order-instructions"
}

export default [
  {
    path: "/dashboard-layout-home",
    component: () => import("@/layouts/dashboard/DashboardLayout.vue"),
    children: [
      {
        path: "/lab-order-instructions/:labOrderRequestId",
        name: "lab-order-instructions",
        component: () =>
          import("@/modules/instructions/pages/primary-care-lab-order-instructions/PrimaryCareLabOrderInstructionsPage.vue"),
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        props: true
      },
      {
        path: `${InstructionsPathUri.OCC_HEALTH_LAB_ORDER_INSTRUCTIONS}/:occupationalHealthLabOrderRequestId`,
        name: "occupational-health-lab-order-instructions",
        component: () =>
          import("@/modules/instructions/pages/occupational-health-lab-order-instructions/OccupationalHealthLabOrderInstructionsPage.vue"),
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        props: true
      },
      {
        path: `${InstructionsPathUri.URGENT_CARE_LAB_ORDER_INSTRUCTIONS}/:urgentCareOrderId`,
        name: "urgent-care-order-instructions",
        component: () =>
          import("@/modules/instructions/pages/occupational-health-urgent-care-order-instructions/OccupationalHealthUrgentCareOrderInstructionsPage.vue"),
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        props: true
      },
      {
        path: "/clinic-confirmation/:clinicId/appointments/:appointmentId",
        name: "clinic-attendance-confirmation",
        component: () => import("@/modules/instructions/pages/ConfirmClinicAttendancePage.vue"),
        props: true
      }
    ]
  }
]
